import * as types from './types';

const INITIAL_STATE = {
  getAllSiteItems: {
    loading: false,
    data: [],
    errors: null,
  },
  postSaveReceipt: {
    loading: false,
    data: null,
    errors: null,
  },
  getReceiptDetails: {
    loading: false,
    data: null,
    errors: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CREATEEDITRECEIPT_GETALLSITEITEMS_LOADING: {
      const { getAllSiteItems } = state;
      return {
        ...state,
        getAllSiteItems: { ...getAllSiteItems, loading: action.payload },
      };
    }
    case types.CREATEEDITRECEIPT_GETALLSITEITEMS_SUCCESS: {
      const { getAllSiteItems } = state;
      return {
        ...state,
        getAllSiteItems: { ...getAllSiteItems, data: action.payload },
      };
    }
    case types.CREATEEDITRECEIPT_GETALLSITEITEMS_ERROR: {
      const { getAllSiteItems } = state;
      return {
        ...state,
        getAllSiteItems: { ...getAllSiteItems, errors: action.payload },
      };
    }

    case types.CREATEEDITRECEIPT_POSTSAVERECEIPT_LOADING: {
      const { postSaveReceipt } = state;
      return {
        ...state,
        postSaveReceipt: { ...postSaveReceipt, loading: action.payload },
      };
    }
    case types.CREATEEDITRECEIPT_POSTSAVERECEIPT_SUCCESS: {
      const { postSaveReceipt } = state;
      return {
        ...state,
        postSaveReceipt: { ...postSaveReceipt, data: action.payload },
      };
    }
    case types.CREATEEDITRECEIPT_POSTSAVERECEIPT_ERROR: {
      const { postSaveReceipt } = state;
      return {
        ...state,
        postSaveReceipt: { ...postSaveReceipt, errors: action.payload },
      };
    }

    case types.CREATEEDITRECEIPT_GETRECEIPTDETAILS_LOADING: {
      const { getReceiptDetails } = state;
      return {
        ...state,
        getReceiptDetails: { ...getReceiptDetails, loading: action.payload },
      };
    }
    case types.CREATEEDITRECEIPT_GETRECEIPTDETAILS_SUCCESS: {
      const { getReceiptDetails } = state;
      return {
        ...state,
        getReceiptDetails: { ...getReceiptDetails, data: action.payload },
      };
    }
    case types.CREATEEDITRECEIPT_GETRECEIPTDETAILS_ERROR: {
      const { getReceiptDetails } = state;
      return {
        ...state,
        getReceiptDetails: { ...getReceiptDetails, errors: action.payload },
      };
    }

    case types.CREATEEDITRECEIPT_CLEARALL: {
      return INITIAL_STATE;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/state/createEditReceipt/reducer.js